// extracted by mini-css-extract-plugin
export default {"melodyVideo":"BJ-z","isFullWidth":"CJ-z","landingPageVideo":"DJ-z","play":"EJ-z","iframeVideo":"FJ-z","playHidden":"GJ-z","fullwidth":"HJ-z"};